<template>
    <section>
        <div class="container mx-auto justify-center py-20">
            <div class="mx-auto w-5/6 text-left md:text-center">
                <h2 class="text-3xl md:text-4xl font-bold mb-8">
                    Get to Know Us
                </h2>

                <p class="text-xl leading-relaxed mb-6">
                    <strong>
                        Fabres Orbis Private Limited (FO GROUPS)
                    </strong>
                    is a multidisciplinary engineering and project solutions
                    company based in Kerala, with over 30 years of combined experience
                    in residential and commercial projects.
                </p>

                <p class="text-xl leading-relaxed mb-6">
                    Our expertise spans Civil and Architectural works,
                    Engineering design, MEP, HVAC, FAPA, Fire System and ELV systems. We also
                    provide Project Management and Consultation (PMC), Turnkey
                    Project Delivery, Operations and Maintenance, and Workforce
                    Support—bringing coordinated expertise to each stage of
                    a project.
                </p>

                <p class="text-xl leading-relaxed mb-6">
                    At FO GROUPS, we combine engineering knowledge, technology,
                    and practical experience to create solutions that meet our
                    clients’ needs and deliver lasting value. We approach every
                    project with attention to detail, a commitment to quality,
                    and respect for the people who will use the spaces and
                    systems we build.
                </p>

                <p class="text-xl leading-relaxed">
                    We aim to grow through innovation, responsible practices,
                    and lasting partnerships—contributing to the progress of
                    our clients, our communities, and the nation.
                </p>
            </div>
        </div>
    </section>
</template>

<script>
export default {};
</script>
